module.exports = __webpack_public_path__ + "static/media/workingmemory-words-12.c250f452.mp3";